/* eslint-disable no-debugger */
import { GET_USER } from '../../actionTypes';
import { debugAction } from '../../utils';

export const user = {
  data: {}
};

export function userReducer(state = user, action) {
  debugAction(action);
  switch (action.type) {
    case GET_USER:
      return { ...state, data: action.payload };
    default:
      return { ...state };
  }
}
